/* eslint-disable jsx-a11y/anchor-has-content */

// node modules
import { useSelector, useDispatch } from 'react-redux';
import useScript from 'react-script-hook';
import { useMutation, gql } from '@apollo/client';

// app modules: actions
import { checkoutEvent } from 'actions/paywall';

const LOG_CHECKOUT_EVENT = gql`
  mutation LogCheckoutEvent($event: String) {
    LogCheckoutEvent(event: $event, provider: "paddle")
  }
`;

function PaddleJS() {
  const vendor = useSelector(state => state.config.paywall.paddleVendorId);
  const sandbox = useSelector(state => state.config.paywall.sandbox);
  const dispatch = useDispatch();
  const [logCheckoutEvent] = useMutation(LOG_CHECKOUT_EVENT);

  // eslint-disable-next-line no-unused-vars
  const [loading, error] = useScript({
    src: 'https://cdn.paddle.com/paddle/paddle.js',
    checkForExisting: true,
    onload: () => {
      if (sandbox) {
        window.Paddle.Environment.set('sandbox');
      }
      window.Paddle.Setup({
        vendor,
        eventCallback: event => {
          dispatch(checkoutEvent(event));
          logCheckoutEvent({ variables: { event: JSON.stringify(event) } });
        },
      });
      dispatch(checkoutEvent({ event: 'LOADED' }));
    },
  });

  if (error) {
    console.error('Failed to load PaddleJS', error);
  }

  return null;
}

PaddleJS.propTypes = {};

export default PaddleJS;
